import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Loader2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { LangToggle } from "@/components/layout/AppShell";
import { Logo } from "@/components/Logo";
import { errMsg } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/demo/links`;

export default function DemoInvite() {
  const { slug } = useParams();
  const { t, startDemo } = useApp();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");
  useEffect(() => { axios.get(`${API}/${slug}/public`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [slug]);
  const go = async () => {
    setBusy(true);
    try {
      if (email.trim()) await axios.post(`${API}/${slug}/lead`, { email: email.trim() }).catch(() => null);
      await startDemo(slug); nav("/app");
    } catch (e) { setErr(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="flex min-h-screen flex-col bg-slate-900 text-white grain">
      <header className="flex items-center justify-between px-6 py-4"><Logo dark size={30} /><LangToggle /></header>
      <main className="flex flex-1 items-center justify-center p-6">
        {!d && !err && <Loader2 className="h-6 w-6 animate-spin text-slate-400" />}
        {err && <div className="text-center" data-testid="demo-invite-error"><p className="text-slate-300">{err}</p><Link to="/" className="mt-4 inline-block text-sm underline">{t("home")}</Link></div>}
        {d && (
          <div className="w-full max-w-lg rounded-3xl bg-white p-10 text-slate-900 shadow-2xl fade-up" data-testid="demo-invite">
            {d.has_logo && <img src={`${API}/${slug}/logo`} alt={d.firm_name} className="mb-6 h-14 w-auto object-contain" data-testid="demo-invite-logo" />}
            <div className="eyebrow !text-[#E30613]">{t("demo_offered_by")}</div>
            <h1 className="mt-2 text-3xl font-bold tracking-tight" data-testid="demo-invite-firm">{d.firm_name}</h1>
            {d.message && <p className="mt-4 whitespace-pre-line text-slate-600" data-testid="demo-invite-message">{d.message}</p>}
            <p className="mt-4 text-sm text-slate-500">{t("demo_invite_sub")}</p>
            <label className="mt-6 block text-xs font-medium text-slate-500">{t("demo_lead_label")}
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@entreprise.tn" className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-900 outline-none focus:border-[#E30613]" data-testid="demo-invite-email" />
            </label>
            <button onClick={go} disabled={busy} className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#E30613] px-6 py-3 text-sm font-semibold text-white hover:bg-[#B8000F]" data-testid="demo-invite-start">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}{t("demo_try")}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180" />
            </button>
          </div>
        )}
      </main>
    </div>
  );
}
